import { getSettingHelpCenterAIChatbotEmergencyStop } from "../settings/getSettingHelpCenterAIChatbotEmergencyStop";
import {
  getSettingHelpCenterBrandAIChatbot,
  getSettingHelpCenterBrandAIChatbotWithoutAssignment,
} from "../settings/getSettingHelpCenterBrandAIChatbot";

// Emergency stop is a global setting that can be used to disable the chatbot for all users.
export const brandChatbotSettingEnabled = () => {
  const isEmergencyStopped = getSettingHelpCenterAIChatbotEmergencyStop();
  const isChatbotEnabled = getSettingHelpCenterBrandAIChatbot();

  if (isEmergencyStopped) {
    return false;
  }
  return isChatbotEnabled;
};

export function brandChatbotSettingEnabledWithoutAssignment(): boolean {
  const isEmergencyStopped = getSettingHelpCenterAIChatbotEmergencyStop();
  const isChatbotEnabled =
    getSettingHelpCenterBrandAIChatbotWithoutAssignment();

  if (isEmergencyStopped) {
    return false;
  }
  return isChatbotEnabled;
}
